import { useCurrencyStore, Currency, CURRENCY_NAMES } from '../../stores/currencyStore';
import { useTranslation } from 'react-i18next';

export function CurrencySelector() {
  const { t } = useTranslation();
  const { currency, setCurrency } = useCurrencyStore();

  const currencies: Currency[] = ['TRY', 'USD', 'EUR'];

  return (
    <div className="relative">
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value as Currency)}
        className="appearance-none bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-gray-100 px-2 py-1 pr-6 rounded-md text-xs font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label={t('common.currency')}
      >
        {currencies.map((curr) => (
          <option key={curr} value={curr}>
            {CURRENCY_NAMES[curr]}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 text-gray-700 dark:text-gray-300">
        <svg className="fill-current h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  );
}
